<template>
  <span class="text-left pl-0">
    <v-icon v-if="getContentTypeAbbr(contentType) === 'image'" large>photo</v-icon>
    <v-icon v-if="getContentTypeAbbr(contentType) === 'video'" large>movie</v-icon>
    <v-icon v-if="getContentTypeAbbr(contentType) === 'audio'" large>audiotrack</v-icon>
  </span>
</template>

<script>
export default {
  name: 'AppContentType',
  props: {
    contentType: {
      type: String,
      default: null
    }
  }
}
</script>
